var _this = this;

import { useCallback, useEffect, useRef } from "react";

var useDebounce = function useDebounce(fn, delay) {
  var _useRef = useRef({
    fn: fn,
    timer: null
  }),
      current = _useRef.current;

  useEffect(function () {
    current.fn = fn;
  }, [current, fn]);
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (current.timer) {
      clearTimeout(current.timer);
    }

    current.timer = setTimeout(function () {
      var _current$fn;

      (_current$fn = current.fn).call.apply(_current$fn, [_this].concat(args));
    }, delay);
  }, [current, delay]);
};

export default useDebounce;